<template>
  <div class="home">
    <div class="box">
      <img class="home-bg" width="210" src="../assets/images/home.png" alt="">

      <h1 class="title">欢迎登录RRT-策略管理平台</h1>
      <h4 class="subtitle">COPYRIGHT © {{thisYear}} RRT</h4>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({name: 'login'});
    }
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    }
  },
}
</script>
<style lang="scss" scoped>
.home {
  height: calc(100vh - 3.5rem - 10.2rem );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .box {
    text-align: center;
  }
  .home-bg {
    margin-bottom: 50px;
  }
  .title {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .subtitle {
    color: #6E6B7B;
    font-size: 14px;
    margin-bottom: 64px;
  }

}
//移动端
@media screen and (max-width: 768px){
  .home {
    height: calc(100vh - 140px);
  }
}
</style>
